export const path = 'https://mbproductapi-prod.vpc3.mnw.no/api/v1'

/**
 * Use to define an endpoint with available http methods
 * @param {string} endpoint
 * @param {('all' | 'one' | 'add' | 'update')[]} methods
 */
export const endpoint = (endpoint, methods) => ({
    ...methods.reduce(
        (acc, action) => ({
            ...acc,
            [action]: httpMethod(`${path}/${endpoint}`)[action]
        }),
        {}
    )
})

/**
 * Generic way to create a http method for an endpoint
 * @param {string} url
 */
const httpMethod = (url) => ({
    async all() {
        return get(url)
    },
    async one(id) {
        return get(`${url}/${id}`)
    },
    async add(body) {
        return post(url, body)
    },
    async update(body) {
        return put(url, body)
    }
})

const get = async (url) => {
    try {
        const result = await (await fetch(url)).json()
        return result
    } catch (error) {
        return error
    }
}

const post = async (url, body) => {
    try {
        const result = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        switch (result.status) {
            case 201:
                return result
            default:
                throw Error
        }
    } catch (error) {
        console.error(error)
        return error
    }
}

const put = async (url, body) => {
    try {
        const result = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        switch (result.status) {
            case 201:
            case 204:
                return result
            default:
                throw Error
        }
    } catch (error) {
        console.error(error)
        return error
    }
}
